import { computed, useScript } from '#imports'

export const useApplePayScript = () => {
    const script = useScript({
        id: 'js-apple-pay-sdk',
        src: 'https://applepay.cdn-apple.com/jsapi/v1.3.5/apple-pay-sdk.js',
    }, {
        trigger: 'manual',
    })

    const isLoaded = computed(() => script.status.value === 'loaded')
    const isSettled = computed(() => script.status.value === 'loaded' || script.status.value === 'error')

    return { ...script, isLoaded, isSettled }
}
